import type { Labels } from 'react-day-picker';
import type { IntlShape } from 'react-intl';

const getLabels = (intl: IntlShape): Partial<Labels> => {
  return {
    labelMonthDropdown: () => intl.formatMessage({ defaultMessage: 'Month' }),
    labelYearDropdown: () => intl.formatMessage({ defaultMessage: 'Year' }),
    labelNext: () => intl.formatMessage({ defaultMessage: 'Go to next month' }),
    labelPrevious: () => intl.formatMessage({ defaultMessage: 'Go to previous month' })
  };
};

export default getLabels;
